import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const includes = ['Personalized image consultation (Value: $20)', 'Precision cut with signature technique', 'Express hydrating treatment', 'At-home maintenance guide'];
export function OfferSection() {
  return <section className="py-24 px-4 bg-matte" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative rounded-2xl p-[1px] bg-gradient-to-b from-gold via-gold/20 to-transparent" data-id="element-83">
          <div className="bg-dark rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-84">
            {/* Background glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold/10 via-transparent to-transparent pointer-events-none" data-id="element-85"></div>

            <h2 className="font-display text-3xl md:text-5xl text-gold mb-10 italic relative z-10" data-id="element-86">
              Your First Visit Includes:
            </h2>

            <div className="max-w-xl mx-auto space-y-4 mb-12 relative z-10 text-left" data-id="element-87">
              {includes.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1
            }} className="flex items-center gap-4 bg-matte/50 p-4 rounded-lg border border-white/5" data-id="element-88">
                  <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-89">
                    <CheckIcon className="w-4 h-4 text-gold" data-id="element-90" />
                  </div>
                  <span className="font-body text-white md:text-lg font-light" data-id="element-91">
                    {item}
                  </span>
                </motion.div>)}
            </div>

            <div className="relative z-10" data-id="element-92">
              <CTAButton pulse className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-93">
                I Want My Transformation
              </CTAButton>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}